import React, { useState, useEffect, useCallback } from "react";
import { motion, useScroll } from "framer-motion";

function ScaleWrapper({
  direction,
  children,
  duration,
  delayInitialCheck,
  delay,
  ...rest
}) {
  const scale = {
    initial: {
      scale: 1.075,
    },
    enter: {
      scale: 1,
      transition: {
        scale: {
          duration: duration * 3,
          delay: delay,
          ease: [0.23, 1, 0.32, 1],
        },
      },
    },
  };

  const [show, setShow] = useState(false);
  const [wrapper, setWrapper] = useState(undefined);
  const measuredRef = useCallback(
    (node) => {
      setTimeout(() => {
        const height =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;
        if (node !== null) {
          if (node.getBoundingClientRect().top < height) {
            setShow(true);
          } else {
            setWrapper(node);
          }
        }
      }, delayInitialCheck);
    },
    [delayInitialCheck],
  );
  const { scrollY } = useScroll();

  useEffect(() => {
    if (wrapper) {
      // On IE, force show state immediately to avoid performance issues
      if (
        navigator.userAgent.indexOf("MSIE") !== -1 ||
        navigator.appVersion.indexOf("Trident/") > -1
      ) {
        setShow(true);
      } else {
        scrollY.on("change", () => {
          const height =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
          if (
            wrapper.getBoundingClientRect().top < height - height / 3 &&
            !show
          ) {
            setShow(true);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapper]);

  return (
    <div ref={measuredRef} {...rest}>
      <motion.div
        variants={scale}
        initial="initial"
        animate={show ? "enter" : "initial"}
      >
        {children}
      </motion.div>
    </div>
  );
}

ScaleWrapper.defaultProps = {
  delay: 0,
  delayInitialCheck: 600,
  duration: 0.6,
};

export default ScaleWrapper;
